/**
 * GUIDED TOUR — REFLOW BRIDGE
 *
 * Step callbacks in `tourSteps.ts` are plain objects, not React components, so
 * they can't call the overlay's internal recompute. The SpotlightOverlay
 * registers its reflow function here once; step `onHighlightStarted` handlers
 * call `requestTourReflow()` after they mutate layout (e.g. opening the mobile
 * menu that hosts a sidebar-mounted target) so the spotlight re-measures.
 *
 * Mirrors tourNavigation.ts / tourMobileMenu.ts.
 */

let reflowRef: (() => void) | null = null;

/** SpotlightOverlay registers/clears its recompute fn on mount/unmount. */
export function setTourReflow(fn: (() => void) | null): void {
  reflowRef = fn;
}

/** Ask the overlay to re-measure the current target/callouts. No-op if unmounted. */
export function requestTourReflow(): void {
  reflowRef?.();
}
